// theme.js
import { extendTheme } from "@chakra-ui/react";
import "@fontsource/montserrat"; // Defaults to weight 400

const theme = extendTheme({
  fonts: {
    heading: "Montserrat, sans-serif",
    body: "Montserrat, sans-serif",
  },
});

export default theme;
